import { createFileRoute } from '@tanstack/react-router'
import { healthQueryOptions, trackingSearchSchema } from '../../src/schemas/routeSchemas'
import { requirePermission } from '../../src/utils/routePermissions'

export const Route = createFileRoute('/tracking')({
  validateSearch: (search) => trackingSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    englishAllowed: true,
    layout: 'menu',
  },
})
